var React = require('react');

function ExpandMore (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16 21.6L30.3 7.3l1.4 1.4L16 24.4.3 8.7l1.4-1.4"})));
}

ExpandMore.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ExpandMore;

ExpandMore.default = ExpandMore;
